import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

export const generatePatientDocument = ({ documentType, objectId }) => {
  return http.post(HTTP_ENDPOINTS.patientDocuments.generate(), {
    document_type: documentType,
    object_id: objectId,
  });
};
